<script setup>

import { ref, onMounted, defineEmits, defineProps, watch, computed } from "vue";
import ERP from "@apiV2/ERP.mjs";
import View from "@apiV2/View.mjs";
import UtilMoney from "@utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "visualizandoParcelasDoJob",
    "recarregaDados",
    "dados",
    
]);

const emits = defineEmits([
    "update:alteraVisualizandoParcelasDoJob",
    "update:alteraDados",
    "update:alteraRecarregaDados"
]);

//==================================================================//
//=================== REF Tabela de Dados ==========================//
//==================================================================//

const refTabelaDeDados = ref(null);

//==================================================================//
//======================= Dados Loading ============================//
//==================================================================//

const dadosLoading = ref(true);

//==================================================================//
//================== Dado Codigo Selecionado =======================//
//==================================================================//

let dadoCodigoSelecionado = ref("");

//==================================================================//
//=================== Dado Cliente Selecionado =====================//
//==================================================================//

let dadoClienteSelecionado = ref("");

//==================================================================//
//============= Altera Visualizando Parcelas do Job ================//
//==================================================================//

const alteraVisualizandoParcelasDoJob = (update)=>{

    emits('update:alteraVisualizandoParcelasDoJob',update);

};

//==================================================================//
//======================== Altera Dados ============================//
//==================================================================//

const alteraDados = (update)=>{

    emits('update:alteraDados',update);

};

//==================================================================//
//======================== Altera Dados ============================//
//==================================================================//

const alteraRecarregaDados = (update)=>{

    emits('update:alteraRecarregaDados',update);

};

//==================================================================//
//============================ Load Dados ==========================//
//==================================================================//

const loadDados = async () =>{

    dadosLoading.value = true;

    const dadosResponse = await ERP.getManyWithView(View.JOB_PARCELAS);
    
    alteraDados(dadosResponse.data);

    dadosLoading.value = false;

};

//==================================================================//
//======================== Dados Codigos ===========================//
//==================================================================//

const dadosCodigos = computed(()=>{

    return props?.dados?.map(({codigo})=> codigo || "");

});

//==================================================================//
//======================== Dados Clientes ==========================//
//==================================================================//

const dadosClientes = computed(()=>{

    return props?.dados?.map(({cliente})=> cliente?.nomeFantasia || "");

});

//==================================================================//
//======================= Dados Filtrados ==========================//
//==================================================================//

const dadosFiltrados = computed(()=>{

    return refTabelaDeDados?.value?.selectableItems || [];

});


//==================================================================//
//=========================== Soma Valor ===========================//
//==================================================================//

const somaValor = computed(()=>{

    return dadosFiltrados.value.reduce((acc,dado)=>{

        if(dado?.valorAtual){
            acc += dado?.valorAtual || 0;
        }

        return acc;

    },0);

});

//==================================================================//
//==================== Soma Valor no Vencimento ====================//
//==================================================================//

const somaValorNoVencimento = computed(()=>{

    return dadosFiltrados.value.reduce((acc,dado)=>{

        if(dado?.valorAtual){
            acc += dado?.parcelasValorNoVencimento || 0;
        }

        return acc;

    },0);

});

//==================================================================//
//===================== Soma Valor na Previsão =====================//
//==================================================================//

const somaValorNaPrevisao = computed(()=>{

    return dadosFiltrados.value.reduce((acc,dado)=>{

        if(dado?.valorAtual){
            acc += dado?.parcelasValorNaPrevisao || 0;
        }

        return acc;

    },0);

});

//==================================================================//
//======================== Filter Codigo ===========================//
//==================================================================//

const filterCodigo = (codigoDado = "") =>{

    let codigoSelecionado = dadoCodigoSelecionado?.value?.toLowerCase();
    codigoDado = codigoDado?.toLowerCase();

    if(codigoSelecionado == ""){
        return true;
    }

    if(codigoDado?.includes(codigoSelecionado)){
        return true;
    }
    
    return false;

}

//==================================================================//
//======================== Filter Cliente ==========================//
//==================================================================//

const filterCliente = (clienteDado = "") =>{

    let clienteSelecionado = dadoClienteSelecionado?.value?.toLowerCase();
    clienteDado = clienteDado?.toLowerCase();

    if(clienteSelecionado == ""){
        return true;
    }

    if(clienteDado?.includes(clienteSelecionado)){
        return true;
    }
    
    return false;

}

//==================================================================//
//========================== Dados Headers =========================//
//==================================================================//

let dadosHeaders = [
    { text: '',                          value: 'visualizar',                     class:"c-dado__header",   cellClass:'c-dado__cell'},
    { text: 'N° do Job',                 value: 'codigo',                         class:"c-dado__header",   cellClass:'c-dado__cell', filter: filterCodigo},
    { text: 'Status',                    value: 'status',                         class:"c-dado__header",   cellClass:'c-dado__cell'},
    { text: 'Descrição',                 value: 'descricao',                      class:"c-dado__header",   cellClass:'c-dado__cell', width: "300"},
    { text: 'Cliente',                   value: 'cliente.nomeFantasia',           class:"c-dado__header",   cellClass:'c-dado__cell', filter: filterCliente},
    { text: 'Valor',                     value: 'valorAtual',                     class:"c-dado__header",   cellClass:'c-dado__cell'},
    { text: 'Valor no Vencimento',       value: 'parcelasValorNoVencimento',      class:"c-dado__header",   cellClass:'c-dado__cell'},
    { text: 'Valor na Previsão',         value: 'parcelasValorNaPrevisao',        class:"c-dado__header",   cellClass:'c-dado__cell'},
    { text: 'Parcelas',                  value: 'parcelasQuantidade',             class:"c-dado__header",   cellClass:'c-dado__cell'},
]

//==================================================================//
//================= Ao Visualizar Parcelas do Job ==================//
//==================================================================//

const aoVisualizarParcelasDoJob = (dado = {})=>{

    alteraVisualizandoParcelasDoJob({
        status: true,
        dado: dado
    });

}

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

    await loadDados();

});

//==================================================================//
//============= Watch => visualizandoParcelasDoJob =================//
//==================================================================//

watch(()=> props.visualizandoParcelasDoJob, async () => {

    if(props.visualizandoParcelasDoJob == false){
        await loadDados();
    }

});

//==================================================================//
//================== Watch => recarregaDados =======================//
//==================================================================//

watch(()=> props.recarregaDados, async () => {

    if(props.recarregaDados == true){
        await loadDados();
        alteraRecarregaDados(false);
    }

});

</script>

<template>

    <v-card class="c-lista-de-dados">

        <v-card-title class="c-lista-de-dados__header">

            <h3 class="c-header__titulo">
                Jobs
            </h3>

            <div class="c-header__buscas">

                <div class="c-busca c-busca--select c-busca--numero-do-dado">

                    <v-select
                        label="N° do Job"
                        class="c-busca__input"
                        v-model="dadoCodigoSelecionado"
                        :items="dadosCodigos"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                    ></v-select>

                </div>

                <div class="c-busca c-busca--select c-busca--cliente">

                    <v-select
                        label="Cliente"
                        class="c-busca__input"
                        v-model="dadoClienteSelecionado"
                        :items="dadosClientes"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                    ></v-select>

                </div>

            </div>

            <v-chip
                class="c-header__usuario"
                label
            >

                <v-icon left>
                    mdi-account-circle-outline
                </v-icon>
                Usuario:
                {{colaboradorStore.colaborador.nome}}

            </v-chip>

            <div
                class="c-header__medidores"
            >

                <div
                    class="c-medidor .c-medidor--valor-dado"
                >

                    <v-chip
                        class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        Valor:
                        {{ UtilMoney.toR$BRL(somaValor) }}

                    </v-chip>

                </div>

                <div
                    class="c-medidor .c-medidor--valor-no-vencimento"
                >

                    <v-chip
                        class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        Valor no Vencimento:
                        {{ UtilMoney.toR$BRL(somaValorNoVencimento) }}

                    </v-chip>

                </div>

                <div
                    class="c-medidor .c-medidor--valor-na-previsao"
                >

                    <v-chip
                        class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        Valor na Previsão:
                        {{ UtilMoney.toR$BRL(somaValorNaPrevisao) }}

                    </v-chip>

                </div>

            </div>

        </v-card-title>

        <v-data-table
            ref="refTabelaDeDados"
            class="c-lista-de-dados__tabela elevation-1"
            :headers="dadosHeaders"
            :items="props.dados"
            :items-per-page="-1"
            select-strategy="all"
            item-key="id"
            return-object
            :loading="dadosLoading"
            loading-text="Carregando... Por favor, aguarde."
        >

            <template v-slot:item.visualizar="{ item }">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-visualizar-dado mx-2"
                            fab
                            dark
                            small
                            color="#32434D"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoVisualizarParcelasDoJob(item)"
                        >

                            <v-icon dark>
                                mdi-eye
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Visualizar as Parcelas do Job</span>

                </v-tooltip>

            </template>

            <template v-slot:item.descricao="{ item }">

                <p class="c-dado__cell--descricao">

                    {{item.descricao}}

                </p>

            </template>

            <template v-slot:item.valorInicial="{ item }">

                {{UtilMoney.toR$BRL(item?.valorInicial)}}

            </template>

            <template v-slot:item.valorAtual="{ item }">

                {{UtilMoney.toR$BRL(item?.valorAtual)}}

            </template>

            <template v-slot:item.parcelasValorNoVencimento="{ item }">

                {{UtilMoney.toR$BRL(item?.parcelasValorNoVencimento)}}

            </template>

            <template v-slot:item.parcelasValorNaPrevisao="{ item }">

                {{UtilMoney.toR$BRL(item?.parcelasValorNaPrevisao)}}

            </template>

            <template v-slot:item.parcelasQuantidade="{ item }">

                <v-chip
                    color="indigo"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-receipt-text
                    </v-icon>
                    {{item?.parcelasQuantidade}}

                </v-chip>

            </template>

        </v-data-table>

    </v-card>

</template>

<style scoped>

.c-lista-de-dados__header{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo titulo"
    "buscas usuario"
    "medidores medidores";
    gap: 10px;
    align-items: start;
}

.c-header__titulo{
    grid-area: titulo;
}

.c-header__buscas{
    grid-area: buscas;
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px;
    grid-template-areas: 
        "buscaCodigo buscaCliente";
}

.c-busca > .c-busca__texto{
    margin: 0;
    font-size: 14px;
}

.c-busca--toogle{
    align-items: center;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
}

.c-busca--toogle > .c-busca__input{
    padding-left: 10px;
}

.c-busca--codigo{
    grid-area: buscaCodigo;
}

.c-busca--cliente{
    grid-area: buscaCliente;
}

.c-header__usuario{
    grid-area: usuario;
    min-height: 48px;
}

.c-header__usuario >>> .v-chip__content{
    margin: auto;
}

.c-header__medidores{
    grid-area: medidores;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
}

.c-lista-de-dados__tabela{
    display: grid;
    white-space: nowrap;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-visualizar-dado{
    background: #32434D !important;
    border-color: #32434D !important;
}

.c-dado__cell--descricao{
    white-space: normal;
    margin: 0px !important;
}

@media (width <= 850px) {
    
    .c-lista-de-dados__header{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "usuario"
            "buscas"
            "medidores";
    }

    .c-header__usuario{
        margin: 0;
    }

    .c-header__buscas { 
        grid-area: buscas;
        display: grid; 
        grid-template-columns: 1fr; 
        grid-template-rows: 1fr 1fr; 
        gap: 10px; 
        grid-template-areas: 
            "buscaCodigo"
            "buscaCliente";
    }

}

</style>
